export default function DownloadAppAppleIcon({ className = "", onClick = null }) {
  return (
    <svg
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 209 209"
    >
      <path d="M129.47,46.91c-6.06,7.15-15.75,12.62-25.2,11.92-1.23-9.65,3.55-19.91,8.91-26.17,6.05-7.1,16.57-12.54,24.97-12.92,1.11,10.03-2.87,19.91-8.68,27.17Z"/>
      <path d="M173.47,144.14c-.13.6-3.48,12.25-11.82,24.07-6.97,10.41-14.26,20.6-25.85,20.78-11.26.26-15.05-6.62-27.97-6.62s-17.06,6.44-27.86,6.88c-11.04.4-19.48-11.11-26.7-21.44-14.42-21.07-25.66-59.37-10.6-85.44,7.3-12.78,20.61-21.02,34.83-21.24,11.05-.22,21.31,7.47,28.1,7.47s19.34-9.2,32.42-7.82c5.47.15,21.03,2.15,31.07,16.79-.81.49-18.54,10.91-18.35,32.32.23,25.66,22.47,34.15,22.73,34.25Z"/>
    </svg>
  );
}
